import { useGoogleLogin } from "@react-oauth/google";
import { useState } from "react";
// import FacebookLogin from "react-facebook-login";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FallingLines } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import facebook from "../../../assets/images/Facebook.png";
import google from "../../../assets/images/Google.png";
import signInLogo from "../../../assets/svg/sign-in-logo.svg";
import axios from "../../../components/Hooks/axios";
import { addAccount } from "../../../redux/slices/accountSlice";
import { setAuth, setUserObject } from "../../../redux/slices/authSlice";
import { validateEmail, validateSignInPassword, validateSignIn } from "../../../utils/authValidation";
import LoadingBg from "../Loading Bg/LoadingBg";
import classes from "./SignIn.module.scss";

const SignIn = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const forgetPasswordHandler = () => {
		navigate("/forget-password");
	};

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [errors, setErrors] = useState({});
	const [touched, setTouched] = useState({});
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [rememberMe, setRememberMe] = useState(false);
	const [passIcon, setPassIcon] = useState(false);

	const handleBlur = (field) => {
		setTouched((prev) => ({ ...prev, [field]: true }));
		if (field === "email") {
			const err = validateEmail(email);
			setErrors((prev) => ({ ...prev, email: err }));
		} else if (field === "password") {
			const err = validateSignInPassword(password);
			setErrors((prev) => ({ ...prev, password: err }));
		}
	};

	const handleEmailChange = (e) => {
		const val = e.target.value;
		setEmail(val);
		if (touched.email || errors.email) {
			setErrors((prev) => ({ ...prev, email: validateEmail(val) }));
		}
	};

	const handlePasswordChange = (e) => {
		const val = e.target.value;
		setPassword(val);
		if (touched.password || errors.password) {
			setErrors((prev) => ({ ...prev, password: validateSignInPassword(val) }));
		}
	};

	const handelSignIn = (e) => {
		if (e && e.preventDefault) e.preventDefault();

		setTouched({ email: true, password: true });
		const cleanEmail = email.trim();
		const { isValid, errors: validationErrors } = validateSignIn({ email: cleanEmail, password });

		if (!isValid) {
			setErrors(validationErrors);
			const firstError = Object.values(validationErrors)[0];
			if (firstError) toast.warn(firstError);
			return;
		}

		setErrors({});
		setBtnDisabled(true);

		const data = JSON.stringify({
			email: cleanEmail,
			password: password,
		});

		axios
			.post("/auth/login", data, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				dispatch(setAuth({ userId: data.data._id, token: data.token, rememberMe }));
				dispatch(setUserObject(data.data));
				axios.defaults.headers.Authorization = data.token;
				setBtnDisabled(false);
				dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
				navigate("/Home", { replace: true });
			})
			.catch(({ response }) => {
				const errMsg = response?.data?.message || response?.data?.error || "Sign in failed";
				toast.error(errMsg);
				setBtnDisabled(false);
			});
	};

	const login = useGoogleLogin({
		onSuccess: (tokenResponse) => {
			axios
				.get(`https://www.googleapis.com/oauth2/v3/userinfo?access_token=${tokenResponse.access_token}`)
				.then(({ data }) => {
					axios
						.post("/auth/googleRegister", { ...data, isLoginOnly: true })
						.then(({ data }) => {
							if (data.status) {
								dispatch(setAuth({ userId: data.data._id, token: data.token }));
								dispatch(setUserObject(data.data));
								axios.defaults.headers.Authorization = data.token;
								setBtnDisabled(false);
								dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
								const hasInterests = data.data?.interestName && data.data.interestName.length > 0;
								const destination = (data.isNewUser || !hasInterests) ? "/interest" : "/Home";
								navigate(destination, { replace: true });
							}
						})
						.catch((e) => {
							toast.error(e.response?.data?.message || "Google Login Failed");
							console.log(e);
						});
				})
				.catch((e) => console.log(e));
		},
		onError: (tokenResponse) => console.log(tokenResponse),
	});

	const responseFacebook = (response) => {
		if (!response.accessToken) {
			toast.error("Facebook Login was cancelled or failed.");
			return;
		}

		axios
			.post("/auth/facebookRegister", { accessToken: response.accessToken, isLoginOnly: true })
			.then(({ data }) => {
				if (data.status) {
					dispatch(setAuth({ userId: data.data._id, token: data.token }));
					dispatch(setUserObject(data.data));
					axios.defaults.headers.Authorization = data.token;
					setBtnDisabled(false);
					dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
					navigate(data.isNewUser ? "/interest" : "/Home", { replace: true });
				}
			})
			.catch((e) => {
				toast.error(e.response?.data?.message || "Facebook Login Failed");
			});
	};

	return (
		<div className={classes["main-container"]}>
			<LoadingBg />
			<div className={classes["sub-container"]}>
				<div className={classes.header}>
					<div className={classes["text-container"]}>
						<p className={classes.heading}>Sign In</p>
						{/* <p className={classes.text}>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Purus est tortor gravida nibh id at.
						</p> */}
					</div>
					<div className={classes.image}>
						<img src={signInLogo} alt="" />
					</div>
				</div>

				<form className={classes.form} onSubmit={handelSignIn} noValidate>
					<div className={classes["input-container"]}>
						<div className={classes.input}>
							<label htmlFor="email" className={classes.label}>
								E-mail
							</label>
							<input
								id="email"
								type="email"
								className={`${classes["input-box"]} ${touched.email && errors.email ? classes.inputError : ""}`}
								placeholder="Enter Your Email"
								value={email}
								onChange={handleEmailChange}
								onBlur={() => handleBlur("email")}
							/>
							{touched.email && errors.email && (
								<span className={classes.errorMessage}>{errors.email}</span>
							)}
						</div>

						<div className={classes.input}>
							<label htmlFor="password" className={classes.label}>
								Password
							</label>

							<div className={`${classes.inputPass} ${touched.password && errors.password ? classes.inputError : ""}`}>
								<input
									id="password"
									type={passIcon ? "text" : "password"}
									placeholder="Enter Your Password"
									value={password}
									onChange={handlePasswordChange}
									onBlur={() => handleBlur("password")}
								/>

								<span onClick={() => setPassIcon(!passIcon)}>
									{passIcon ? <FaEye size={"2.5rem"} /> : <FaEyeSlash size={"2.5rem"} />}
								</span>
							</div>
							{touched.password && errors.password && (
								<span className={classes.errorMessage}>{errors.password}</span>
							)}

							<Link to="/signup" className={classes.ArrowBtn}>
								{">"}
							</Link>
						</div>

						<div className={classes["forget-remember"]}>
							<section className={classes.remember}>
								<input
									type="checkbox"
									className={classes["radio-button"]}
									checked={rememberMe}
									onChange={(e) => setRememberMe(e.target.checked)}
									id="Remember_me"
								/>
								<label htmlFor="Remember_me" className={classes["remember-me"]}>
									Remember me
								</label>
							</section>
							<p className={classes.link} onClick={forgetPasswordHandler}>
								Forget Password
							</p>
						</div>
					</div>

					<div className={classes.actions}>
						<button type="submit" className={classes.btn} disabled={btnDisabled}>
							{btnDisabled ? (
								<FallingLines color="#fff" width="60" visible={true} ariaLabel="falling-lines-loading" />
							) : (
								"Sign In"
							)}
						</button>
					</div>

					<div className={classes.design}>
						<div className={classes.line}></div>
						<p className={classes.continue}>Continue With</p>
						<div className={classes.line}></div>
					</div>

					<div className={classes.footer}>
						<button type="button" onClick={() => login()} title="Sign in with Google">
							<img src={google} alt="Google" />
						</button>

						<FacebookLogin
							appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
							autoLoad={false}
							scope="email"
							fields="name,email,picture"
							callback={responseFacebook}
							render={(renderProps) => (
								<button type="button" onClick={renderProps.onClick} title="Sign in with Facebook">
									<img src={facebook} alt="Facebook" />
								</button>
							)}
						/>
					</div>
				</form>
			</div>
		</div>
	);
};

export default SignIn;

